import React from "react";
import { Link } from "react-router-dom";
import "./style.css";
function Navbar() {
  return (
    <footer className="bg-dark page-footer">
        <div className="social-icons">
          <a className="text-secondary" href="https://github.com/DVasquez4155">
            <i className="fab fa-github"></i>
          </a>
          <a className="linkedin" href="https://www.linkedin.com/in/dvasquezt">
            <i className="icon ion-social-linkedin"></i>
          </a>
          <a className="text-success" href="mailto:contact@dvas4155.com">
            <i className="icon ion-email"></i>
          </a>
          <a className="instagram" href="https://www.instagram.com/wdan193/">
            <i className="icon ion-social-instagram"></i>
          </a>
        </div>
        <div className="container">
            <div className="links">
              
              <Link to="/about">About me</Link>
              <Link to="/contact">Contact me</Link>
              <Link to="/projects">Projects</Link>
            </div>
        </div>
    </footer>
  );
}

export default Navbar;
